<template>
  <div class="noise-head">
    <!-- <Pressure v-show="showPressure" :preparam="preParam" :flag="true" />
        <Free v-show="showFree" :freeparam="freeParam" :flag="true" />
        <Grateful v-show="showGrateful" :graparam="graParam" :flag="true" />
        <Atmosphere v-show="showAtmosphere" :atmparam="atmParam" :flag="true" /> -->
    <Currency
      :atmparam="itemData"
      :index="itemData.index"
    />
    <div
      class="content"
      ref="dody"
    >
      <div
        class="content-msg"
        v-for="(item,index) in msglist"
        :key="index"
      >
        <div class="msg">
          <div class="avatar">
            <img
              src="/public/static/home/img/bear.png"
              alt=""
            >
          </div>
          <div class="user">
            抱抱熊小智
          </div>
          <div
            class="information"
            v-html="item"
          ></div>
          <div class="triangle"></div>
        </div>
      </div>
    </div>
    <div class="footer">
      <div
        class="footer-mic"
        @click="appendWord"
      >
        <img
          src="/public/static/home/img/mic.png"
          alt="mic"
          title="mic"
        >
        <p>开始呐喊</p>
      </div>
    </div>
    <audio
      v-for="(item,index) in musicList"
      :key="index"
      :src="'https://nahan.zhixinxinli888.com/' + item.music"
    ></audio>
    <div
      class="sound-mask"
      v-show="soundmask"
    >
      <div class="mask-panel">
        <div class="panel-header">
          正在录音...
        </div>
        <div class="panel-wave">
          <div
            class="note"
            id="bar"
          >
            <div
              :class="'bar' + index"
              v-for="index in 12"
              :key="index"
            ></div>
          </div>
        </div>
        <div
          class="panel-btn"
          id="movepanel"
        >
          <span class="btn-left">取消</span>
          <span class="btn-right">确定</span>
          <div
            class="btn"
            id="movebtn"
          >
            <img
              src="/public/static/home/img/wave.png"
              alt=""
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// import Pressure from "../components/Pressure";
// import Atmosphere from "../components/Atmosphere";
// import Free from "../components/Free";
// import Grateful from "../components/Grateful";
import Currency from "../components/Currency";
export default {
  components: {
    // Pressure,
    // Grateful,
    // Atmosphere,
    // Free,
    Currency,
  },
  data () {
    return {
      msglist: ['hi，你好，我是抱抱熊小智！', '<p class="p-font">你可以试着大声喊：例如，</p> <p class="p-font">我是最棒的人，我最帅，最厉害!</p> <p class="p-font">我要一展才华，我要发财！</p><p class="p-font">xxx你是我最讨厌的人，我要打败你！</p><p class="p-font">之类，来发泄心中的压力。</p>'],
      showPressure: false,
      showGrateful: false,
      showAtmosphere: false,
      showFree: false,
      param: '--',
      preParam: {},
      freeParam: {},
      graParam: {},
      atmParam: {},
      musicList: [],
      audioCtx: {},
      soundmask: false,
      musicObj: [],
      dataList: [],
      itemData: {
        id: '',
        name: '',
        remark: '',
        img: '',
        index: '',
      },
    }
  },
  created () {
    //   if(localStorage.getItem('param')){
    //       let data = JSON.parse(localStorage.getItem('param'));
    //         this.preParam = data[0];
    //         this.freeParam = data[1];
    //         this.graParam = data[2];
    //         this.atmParam = data[3];
    //   }else{
    //     this.$server.postAPI('list').then(res => {
    //         this.preParam = res[0];
    //         this.freeParam = res[1];
    //         this.graParam = res[2];
    //         this.atmParam = res[3];
    //     })
    //   }
    this.itemData.id = this.$route.query.id
    this.itemData.name = this.$route.query.name
    this.itemData.remark = this.$route.query.remark
    this.itemData.img = this.$route.query.img
    this.itemData.index = this.$route.query.index
    this.$server.postAPI('info', { 'cat_id': this.itemData.id }).then(res => {
      this.musicList = res;
    })
    this.moveBtnDiv();
  },
  methods: {
    appendWord () {
      document.getElementById('movebtn').style.left = 40 + '%';
      let _this = this;
      this.soundmask = true;
      window.AudioContext = window.AudioContext || window.webkitAudioContext || window.mozAudioContext || window.msAudioContext;
      // let audioContext = new window.AudioContext();
      _this.audioCtx = new window.AudioContext();
      let mediaStreamSource = null
      let scriptProcessor = null

      if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
        // 获取用户的 media 信息
        navigator.mediaDevices.getUserMedia({ audio: true }).then((stream) => {
          // 将麦克风的声音输入这个对象
          mediaStreamSource = _this.audioCtx.createMediaStreamSource(stream)
          // 创建一个音频分析对象，采样的缓冲区大小为4096，输入和输出都是单声道
          scriptProcessor = _this.audioCtx.createScriptProcessor(4096, 1, 1)
          // 将该分析对象与麦克风音频进行连接
          mediaStreamSource.connect(scriptProcessor)
          // 此举无甚效果，仅仅是因为解决 Chrome 自身的 bug
          scriptProcessor.connect(_this.audioCtx.destination)
          // 开始处理音频
          scriptProcessor.onaudioprocess = function (e) {
            // 获得缓冲区的输入音频，转换为包含了PCM通道数据的32位浮点数组
            let buffer = e.inputBuffer.getChannelData(0)
            // 获取缓冲区中最大的音量值
            let maxVal = Math.max.apply(Math, buffer)
            // 显示音量值
            // let audio = document.getElementById('music');
            let decibel = Math.round(maxVal * 100);
            _this.musicNote();
            if (decibel > 20) {
              _this.playMusic()
            }
          };
        }).catch((error) => {
          this.$toast('获取音频时好像出了点问题。')
        })
      } else {
        this.$toast('不支持获取媒体接口')
      }
    },
    handleTop () {
      this.$nextTick(() => {
        this.$refs.dody.scrollTop = this.$refs.dody.scrollHeight
      });
    },
    handleShow (val) {
      if (val == 1) {
        this.showPressure = !this.showPressure;
      } else if (val == 2) {
        this.showFree = !this.showFree;
      } else if (val == 3) {
        this.showGrateful = !this.showGrateful;
      } else {
        this.showAtmosphere = !this.showAtmosphere;
      }
    },
    fRandomBy (under, over) {
      switch (arguments.length) {
        case 1: return parseInt(Math.random() * under + 1);
        case 2: return parseInt(Math.random() * (over - under + 1) + under);
        default: return 0;
      }
    },
    playMusic () {
      let _this = this;
      let audioAll = document.getElementsByTagName("audio");
      let current = this.fRandomBy(0, this.musicList.length - 1);
      for (let i = 0; i < audioAll.length; i++) {
        if (current == i) {
          _this.musicObj = [];
          _this.musicObj.push({
            music: audioAll[current],
            con: _this.musicList[current].content
          })
        }
      }
    },
    moveBtnDiv () {
      let me = this;
      this.$nextTick(() => {
        let $body = document.getElementsByTagName('body')[0], $btn = document.getElementById('movebtn'), index = 0, x1, leftDistance, left_right, _left;
        $btn.addEventListener('touchstart', function (e) {
          index = 1;
          let _x = e.touches[0].pageX;
          _left = this.offsetLeft
          x1 = _x - _left;
          leftDistance = this.parentNode.offsetLeft / 2 - 10;
          left_right = $body.offsetWidth - x1;
        });
        $btn.addEventListener('touchmove', function (e) {
          if (index === 1) {
            let moveX = e.touches[0].pageX;
            let distance = moveX - x1;
            if (this.offsetLeft > leftDistance) {
              if (this.offsetLeft > _left) {
                if (this.offsetLeft < left_right - 45) {
                  this.style.left = distance + 'px';
                } else {
                  me.soundmask = false
                  me.musicObj[0].music.play();
                  me.audioCtx.close();
                  me.msglist.push(me.musicObj[0].con);
                  me.handleTop();
                  return false
                }
              } else {
                this.style.left = distance + 'px';
              }
            } else {
              me.soundmask = false
              return false
            }
          }
        })

      });
    },
    musicNote () {
      let self = this;
      this.$nextTick(() => {
        let $bar = document.getElementById('bar');
        for (let item of $bar.childNodes) {
          item.style.height = self.fRandomBy(0, 100) + '%'
        }
      })
    }
  },
  destroyed () {
    this.audioCtx.close()
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      const id = to.query.id;
      vm.handleShow(id)
    });
  }
}
</script>
<style lang="scss" scoped>
.noise-head {
  width: 100%;
  height: 100%;
  position: relative;
  .pressure {
    margin: 0;
    border-radius: 0;
  }
  .content {
    width: 100%;
    height: calc(100% - 560px);
    background-color: #f0f0f0;
    overflow: auto;
    .content-msg {
      margin-top: 40px;
      margin-bottom: 40px;
      .msg {
        display: block;
        width: calc(100% - 146px);
        margin-left: 40px;
        position: relative;
        .avatar {
          width: 120px;
          height: 120px;
          > img {
            max-width: 100%;
            width: 100%;
          }
        }
        .user {
          position: absolute;
          top: 0;
          left: 165px;
          font-size: 28px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: rgba(51, 51, 51, 1);
        }
        .information {
          display: block;
          margin-top: -50px;
          margin-left: 160px;
          width: calc(100% - 271px);
          height: auto;
          background: rgba(255, 255, 255, 1);
          border-radius: 20px;
          padding: 44px 35px 45px 49px;
          font-size: 42px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: rgba(51, 51, 51, 1);
        }
        .triangle {
          position: absolute;
          left: 128px;
          top: 110px;
          width: 0;
          height: 0;
          border-width: 15px;
          border-style: solid;
          border-color: transparent #ffffff transparent transparent;
        }
      }
    }
  }
  .footer {
    width: 100%;
    height: 300px;
    background-color: #ffffff;
    position: absolute;
    bottom: 0;
    display: flex;
    justify-content: center;
    .footer-mic {
      width: 200px;
      height: 200px;
      margin-top: 21px;
      img {
        width: 100%;
        max-width: 100%;
      }
      p {
        width: 200px;
        text-align: center;
        font-size: 42px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: rgba(51, 51, 51, 1);
      }
    }
  }
  .sound-mask {
    position: fixed;
    top: 0;
    left: 0;
    background: rgba(0, 0, 0, 0.7);
    width: 100%;
    height: 100%;
    .mask-panel {
      width: 100%;
      height: 900px;
      background-color: #ffffff;
      position: absolute;
      bottom: 0;
      .panel-header {
        width: 100%;
        height: 160px;
        border-bottom: 1px solid #f7f7f7;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 50px;
        color: #333333;
      }
      .panel-wave {
        width: 100%;
        height: 460px;
        background-color: #ffffff;
        display: flex;
        justify-items: center;
        align-items: center;
        .note {
          width: 440px;
          height: 120px;
          margin: auto;
          position: relative;
          .bar1 {
            position: absolute;
            bottom: 0;
            left: 20px;
            width: 15px;
            background-color: rgb(117, 98, 240);
            display: inline-block;
          }
          .bar2 {
            position: absolute;
            bottom: 0;
            left: 60px;
            width: 15px;
            background-color: rgb(117, 98, 240);
            display: inline-block;
          }
          .bar3 {
            position: absolute;
            bottom: 0;
            left: 100px;
            width: 15px;
            background-color: rgb(117, 98, 240);
            display: inline-block;
          }
          .bar4 {
            position: absolute;
            bottom: 0;
            left: 140px;
            width: 15px;
            background-color: rgb(117, 98, 240);
            display: inline-block;
          }
          .bar5 {
            position: absolute;
            bottom: 0;
            left: 180px;
            width: 15px;
            background-color: rgb(117, 98, 240);
            display: inline-block;
          }
          .bar6 {
            position: absolute;
            bottom: 0;
            left: 220px;
            width: 15px;
            background-color: rgb(117, 98, 240);
            display: inline-block;
          }
          .bar7 {
            position: absolute;
            bottom: 0;
            left: 260px;
            width: 15px;
            background-color: rgb(117, 98, 240);
            display: inline-block;
          }
          .bar8 {
            position: absolute;
            bottom: 0;
            left: 260px;
            width: 15px;
            background-color: rgb(117, 98, 240);
            display: inline-block;
          }
          .bar9 {
            position: absolute;
            bottom: 0;
            left: 300px;
            width: 15px;
            background-color: rgb(117, 98, 240);
            display: inline-block;
          }
          .bar10 {
            position: absolute;
            bottom: 0;
            left: 340px;
            width: 15px;
            background-color: rgb(117, 98, 240);
            display: inline-block;
          }
          .bar11 {
            position: absolute;
            bottom: 0;
            left: 380px;
            width: 15px;
            background-color: rgb(117, 98, 240);
            display: inline-block;
          }
          .bar12 {
            position: absolute;
            bottom: 0;
            left: 420px;
            width: 15px;
            background-color: rgb(117, 98, 240);
            display: inline-block;
          }
        }
      }
      .panel-btn {
        width: 1000px;
        height: 200px;
        background-color: #f7f7f7;
        margin: auto;
        border-radius: 100px;
        position: relative;
        .btn-left {
          position: absolute;
          font-size: 36px;
          color: #999999;
          line-height: 200px;
          left: 90px;
        }
        .btn-right {
          position: absolute;
          right: 90px;
          font-size: 36px;
          color: #0acc60;
          line-height: 200px;
        }
        .btn {
          width: 200px;
          height: 200px;
          position: absolute;
          left: 400px;
          > img {
            max-width: 100%;
            width: 100%;
          }
        }
      }
    }
  }
}
</style>
